import React from 'react';

const LoadingSpinner = ({ fullPage = false, size = 'md', text = 'Cargando...', inline = false }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  const spinner = (
    <div className={`flex items-center justify-center ${inline ? '' : 'flex-col'}`}>
      <div
        className={`${sizeClasses[size]} inline-block animate-spin rounded-full border-4 border-astra-primary-500 border-t-transparent`}
      ></div>
      {text && (
        <p className={`${inline ? 'ml-2' : 'mt-4'} text-astra-accent-500`}>{text}</p>
      )}
    </div>
  );

  if (fullPage) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          {spinner}
        </div>
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;
